export default "__VITE_ASSET__DypbWaN9__"